import React from 'react';
import cn from '@/utils/cn';
import Eyebrow from './Eyebrow';

// The screener's verdict leads the dialog: accent rule, subtle fill, body-size text.
const ReasonCallout = ({ reason }: { reason: string | null }) => (
  <div
    className={cn(
      'tw-box-border tw-rounded-r-lg tw-border-0 tw-border-l-2 tw-border-solid tw-border-spa-accent',
      'tw-bg-spa-bg-tertiary tw-px-4 tw-py-3',
    )}
  >
    <Eyebrow className="tw-mb-1">Reason</Eyebrow>
    <p className="tw-m-0 tw-text-base tw-leading-relaxed tw-text-spa-heading">{reason}</p>
  </div>
);

export default ReasonCallout;
